export const USER_LOGIN_SUCCESS =  "USER_LOGIN_SUCCESS";
export const USER_LOGOUT =  "USER_LOGOUT";
export const USER_LOGIN_FAILURE =  "USER_LOGIN_FAILURE";
export const API_SERVER_ERROR = "API_SERVER_ERROR"
